import { Component, OnInit, Input } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss']
})
export class SwitchComponent implements OnInit {
  @Input('label') label: string;
  @Input('type') type = 'default';

  constructor() { }

  ngOnInit() {
  }

  getType() {
    switch (this.type) {
      case 'default':
        return 'p-default p-curve';
      case 'round':
        return 'p-default p-round';
      case 'toggle':
        return 'p-switch p-fill';
      case 'toggle-default':
        return 'p-switch';
    }
  }

  getSuccessState() {
    switch (this.type) {
      case 'default':
        return 'p-success-o';
      case 'round':
        return 'p-success-o';
      case 'toggle':
        return 'p-success';
      case 'toggle-default':
        return '';
    }
  }

}
